module.exports = __webpack_public_path__ + "static/img/articlepro1.99aad86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/propaganda/articlepro1.jpg
// module id = IeW9
// module chunks = 1